import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { ThoughtReadPage } from "@/pages/diary"

const searchSchema = z.object({
	edit: z.coerce.number().int().optional().catch(undefined),
})

export const Route = createFileRoute("/_authenticated/diary/$thoughtId")({
	validateSearch: searchSchema.parse,
	component: ThoughtReadPage,
})
